import Base from './Base';

export default class Media extends Base {
    get isImage() {
        if (this.source) {
            const url = new URL(this.source).pathname;
            const splitUrl = url.split('.');
            const typeCustom = splitUrl[splitUrl.length - 1];

            if (
                typeCustom === 'png' ||
                typeCustom === 'jpeg' ||
                typeCustom === 'jpg' ||
                typeCustom === 'gif' ||
                typeCustom === 'bmp'
            ) {
                return true;
            }
        }

        return [
            'image/format',
            'image/png',
            'image/jpeg',
            'image/gif',
            'image/bmp'
        ].includes(this.content_type);
    }

    get isVideo() {
        return this.content_type?.includes('video');
    }

    get isAudio() {
        return this.content_type?.includes('audio');
    }

    get isApplication() {
        return this.content_type?.includes('application');
    }

    get isGif() {
        return ['image/gif'].includes(this.content_type);
    }

    get isExternalApplicationPdf() {
        return ['application/pdf'].includes(this.content_type);
    }

    get isSupportWebVideo() {
        return ['video/mp4', 'video/ogg', 'video/webm'].includes(this.content_type);
    }

    get isVcard() {
        return ['text/vcard', 'text/x-vcard', 'text/x-vcard; charset=utf-8'].includes(this.content_type);
    }

    get isParsedVCard() {
        return this.hasOwnProperty('parsedVCard') && !Array.isArray(this.parsedVCard);
    }

    get parsedVCardFullName() {
        if (this.isParsedVCard) {
            if (this.parsedVCard.first_name || this.parsedVCard.last_name) {
                return `${this.parsedVCard.first_name} ${this.parsedVCard.last_name}`;
            } else {
                return this.parsedVCard.phone;
            }
        }

        return '';
    }

    get isMediaPreview() {
        return Boolean(this.media_preview)
    }

    get filename() {
        let url = this.source;
        return url.substring(url.lastIndexOf('/') + 1);
    }
}
